module.exports = __webpack_public_path__ + "static/img/role.2f3e9a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/zxrx/role.png
// module id = /MLT
// module chunks = 7